import {
    RiAlignLeft,
    RiAlignCenter,
    RiAlignRight,
    RiAlignTop,
    RiAlignVertically,
    RiAlignBottom,
    RiGroupLine,
    RiGroup2Line,
    RiLayoutRowLine,
    RiLayoutColumnLine,
} from 'react-icons/ri'
import { alignObjects, distributeObjects, groupSelected, ungroupSelected } from '@/lib/canvasAlignment'
import { useEditorStore } from '@/stores/useEditorStore'
import styles from './AlignmentPanel.module.css'

export function AlignmentPanel() {
    const { selectedObjectIds } = useEditorStore()
    const selCount = selectedObjectIds.length

    return (
        <div className={styles.panel}>
            <h3 className={styles.title}>Alineación</h3>

            <div className={styles.section}>
                <span className={styles.sectionLabel}>Alinear</span>
                <div className={styles.alignGrid}>
                    <button
                        className={styles.alignBtn}
                        title="Alinear izquierda"
                        onClick={() => alignObjects('left')}
                        disabled={selCount < 1}
                    >
                        <RiAlignLeft />
                    </button>
                    <button
                        className={styles.alignBtn}
                        title="Centrar horizontal"
                        onClick={() => alignObjects('centerH')}
                        disabled={selCount < 1}
                    >
                        <RiAlignCenter />
                    </button>
                    <button
                        className={styles.alignBtn}
                        title="Alinear derecha"
                        onClick={() => alignObjects('right')}
                        disabled={selCount < 1}
                    >
                        <RiAlignRight />
                    </button>
                    <button
                        className={styles.alignBtn}
                        title="Alinear arriba"
                        onClick={() => alignObjects('top')}
                        disabled={selCount < 1}
                    >
                        <RiAlignTop />
                    </button>
                    <button
                        className={styles.alignBtn}
                        title="Centrar vertical"
                        onClick={() => alignObjects('centerV')}
                        disabled={selCount < 1}
                    >
                        <RiAlignVertically />
                    </button>
                    <button
                        className={styles.alignBtn}
                        title="Alinear abajo"
                        onClick={() => alignObjects('bottom')}
                        disabled={selCount < 1}
                    >
                        <RiAlignBottom />
                    </button>
                </div>
            </div>

            <div className={styles.section}>
                <span className={styles.sectionLabel}>Distribuir</span>
                <div className={styles.distributeRow}>
                    <button
                        className={styles.alignBtn}
                        title="Distribuir horizontal"
                        onClick={() => distributeObjects('horizontal')}
                        disabled={selCount < 3}
                        style={{ flex: 1 }}
                    >
                        <RiLayoutColumnLine />
                    </button>
                    <button
                        className={styles.alignBtn}
                        title="Distribuir vertical"
                        onClick={() => distributeObjects('vertical')}
                        disabled={selCount < 3}
                        style={{ flex: 1 }}
                    >
                        <RiLayoutRowLine />
                    </button>
                </div>
            </div>

            <div className={styles.section}>
                <span className={styles.sectionLabel}>Agrupar</span>
                <button
                    className={styles.groupBtn}
                    onClick={() => groupSelected()}
                    disabled={selCount < 2}
                >
                    <RiGroupLine />
                    Agrupar (Ctrl+G)
                </button>
                <button
                    className={styles.groupBtn}
                    onClick={() => ungroupSelected()}
                >
                    <RiGroup2Line />
                    Desagrupar (Ctrl+Shift+G)
                </button>
            </div>
        </div>
    )
}
